// Module
var code = "<ngx-signup (navigated)=\"$ctrl.onNavigate($event)\" [course-invite]=\"$ctrl.courseInvite\" [info-key]=\"$ctrl.infoKey\" [mode]=\"$ctrl.SIGNUPMODES.EDUCATION\" [login-link]=\"'#'\"></ngx-signup>";
// Exports
module.exports = code;